import superMeta from '../_DESIGN/metaDesignNode.mjs'

export default {
    ...superMeta,
    classes: ['abstract', ...superMeta.classes],
}
